<template>
    <div class="inline-block">
        <button
            class="btn btn-md is-ghost is-danger text-xs"
            @click="$modal.show('delete-land-property')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-land-property"
            primary-button-text="Radera fastighet"
            primary-button-class="is-danger"
            title="Radera fastighet"
            :redirect-to="route('admin.delivery-projects.land-properties.index', deliveryProject)"
            method="delete"
            :action="route('api.delivery-projects.land-properties.destroy', [deliveryProject, landProperty])"
        >
            <p>
                Är du säker på att du vill radera fastigheten?<br>
                Observera, om du raderar en fastighet kommer även uppladdade avtal på fastigheten att raderas.
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            deliveryProject: {
                type: Object,
                required: true,
            },
            landProperty: {
                type: Object,
                required: true,
            },
        },
    };
</script>
